var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRaiting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 15,
    viewBox: "0 0 74 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0L9.18386 5.18237H14.6329L10.2245 8.38525L11.9084 13.5676L7.5 10.3647L3.09161 13.5676L4.77547 8.38525L0.367076 5.18237H5.81614L7.5 0Z",
    fill: "#F8E582"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 0L24.1839 5.18237H29.6329L25.2245 8.38525L26.9084 13.5676L22.5 10.3647L18.0916 13.5676L19.7755 8.38525L15.3671 5.18237H20.8161L22.5 0Z",
    fill: "#F8E582"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 0L39.1839 5.18237H44.6329L40.2245 8.38525L41.9084 13.5676L37.5 10.3647L33.0916 13.5676L34.7755 8.38525L30.3671 5.18237H35.8161L37.5 0Z",
    fill: "#F8E582"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5 0L53.1839 5.18237H58.6329L54.2245 8.38525L55.9084 13.5676L51.5 10.3647L47.0916 13.5676L48.7755 8.38525L44.3671 5.18237H49.8161L51.5 0Z",
    fill: "#F8E582"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5 0L68.1839 5.18237H73.6329L69.2245 8.38525L70.9084 13.5676L66.5 10.3647L62.0916 13.5676L63.7755 8.38525L59.3671 5.18237H64.8161L66.5 0Z",
    fill: "#F8E582"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaiting);
export default __webpack_public_path__ + "static/media/raiting.dc97c3bb427b7a4bbb3e55c45a4e8181.svg";
export { ForwardRef as ReactComponent };